import React, { useEffect, useTransition } from "react";
import { useState } from "react";
import DownloadButton from "../../Buttons/DownloadButton";
import GalleryModal from "./../GalleryModal/GalleryModal";
import "./GalleryItem.css";
import AddToCartButton from "../../Buttons/AddToCartButton";
import { Badge } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { removeItem } from "../../../Reducers/cartReducer";
import { useSelector } from "react-redux";

const GalleryItem = ({ item }) => {
  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showRemove, setShowRemove] = useState(false);

  const cartItems = useSelector((state) => state.cart.items);

  const dispatch = useDispatch();

  const { t } = useTransition();

  useEffect(() => {
    const existingItem = cartItems.find(
      (el) => el.globalAssetId === item.globalAssetId
    );

    if (existingItem) {
      setShowRemove(true);
    }
  }, []);

  useEffect(() => {
    const existingItem = cartItems.find(
      (el) => el.globalAssetId === item.globalAssetId
    );

    if (!existingItem) {
      setShowRemove(false);
    } else {
      setShowRemove(true);
    }
  }, [cartItems]);

  const showInfo = () => {
    setShow(true);
  };

  const hideInfo = () => {
    setShow(false);
  };

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const removeFromCart = (e) => {
    e.stopPropagation();
    dispatch(removeItem(item.globalAssetId));
    setShowRemove(false);
  };

  return (
    <>
      {item && (
        <GalleryModal show={showModal} handleClose={handleClose} item={item} />
      )}
      <div
        className="media-container"
        onMouseEnter={showInfo}
        onMouseLeave={hideInfo}
        onClick={handleShow}
      >
        <img className="img" src={item.coverUrl} alt="gallery item" />
        {item.type === "video" && (
          <div className="play-btn">
            <i className="bi bi-play-circle"></i>
          </div>
        )}
        <div
          className={`media-info top ${show || showRemove ? "show-info" : ""}`}
        >
          <div>
            <span className="ship-onboard">
              <strong>{item.ship}</strong>{" "}
              {item.onboard
                ? Array.isArray(item.onboard)
                  ? item.onboard.join(", ")
                  : item.onboard
                : ""}
            </span>
          </div>
          <div>
            <span className="description">{item.description}</span>
          </div>
          <div>
            <span>
              {item.size} {item.format}
            </span>
          </div>
        </div>
        <div
          className={`media-info bottom ${
            show || showRemove ? "show-info" : ""
          }`}
        >
          {!showRemove ? (
            <>
              {item.type !== "video" && (
                <AddToCartButton item={item} setShow={setShowRemove} />
              )}
              <DownloadButton item={item} />
            </>
          ) : (
            <Badge
              bg="danger"
              className="custom-button position-static pull-right"
              role="button"
              onClick={(e) => removeFromCart(e)}
            >
              {t("remove")}
            </Badge>
          )}
        </div>
      </div>
    </>
  );
};

export default GalleryItem;
